// Client-Side Application — Entry Point
import { initMarkdown } from './markdown';
import { initPageContext } from './pageContext';
import { connectWebSocket, sendMessage } from './websocket';
import {
    chatForm, chatInput, sendBtn,
    clearChatBtn,
    fullscreenBtn,
    enableInput,
    resizeInput,
    restoreWelcomeMessage,
    releaseMessageBubble,
    toggleFullscreen,
} from './ui.js';
import { refreshSessionId, setIsGenerating } from './state.js';

// ─── Bootstrap ────────────────────────────────────────────────────────────────

initMarkdown();
initPageContext();

// ─── Form Submit ──────────────────────────────────────────────────────────────

chatForm.addEventListener('submit', (e) => {
    e.preventDefault();
    const text = chatInput.value.trim();
    if (text) {
        releaseMessageBubble('error');
        sendMessage('requestAIResponse', text);
        chatInput.value = '';
        resizeInput();
    }
});

// ─── Input: auto-resize & send-button state ───────────────────────────────────

chatInput.addEventListener('input', () => {
    sendBtn.disabled = chatInput.value.trim() === '';
    resizeInput();
});

chatInput.addEventListener('keydown', (e) => {
    // Send on Enter; allow Shift+Enter for newlines
    if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        chatForm.requestSubmit();
    }
});

// ─── Suggestion Chips ─────────────────────────────────────────────────────────

restoreWelcomeMessage(sendMessage);

// ─── Fullscreen Toggle ────────────────────────────────────────────────────────

fullscreenBtn.addEventListener("click", toggleFullscreen);

// ─── Clear Chat ───────────────────────────────────────────────────────────────

clearChatBtn.addEventListener('click', () => {
    if (!confirm('Are you sure you want to clear your chat history?')) return;

    setIsGenerating(false);
    refreshSessionId();
    // Rebuild the welcome panel by cloning from the template
    restoreWelcomeMessage(sendMessage);

    enableInput();
    chatInput.value = '';
    resizeInput();
    chatInput.focus();
});

// ─── Initialize ───────────────────────────────────────────────────────────────

connectWebSocket();
resizeInput();
chatInput.focus();
